import React, {Component} from "react";
import {Col, Input, Row, Tooltip} from "antd";
import {get} from "../../../helper/request";

class CaseSearchInputComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            inputValue: '',
            name_suggestions: [],
            selectedCaseID: '',
            selectedSlideNumber: '',
        }
    }

    selectFolderName = (event) => {
        let value = event.target.value;
        this.props.setFolderName(value);
    }

    render() {
        return (
            <Tooltip title={"Folder Name"}>
                <Row>
                    <Col>
                        <Input value={this.props.value} onChange={this.selectFolderName} placeholder={"Enter folder name"} />
                    </Col>
                </Row>
            </Tooltip>
        )
    }
}

export default CaseSearchInputComponent;
